import { createActionCreator } from '../../utils/helpers';
import { loginOpenId, openId, signupOpenId } from './types';

export const requestLoginOpenId = createActionCreator(loginOpenId.request, 'payload');
export const requestLoginOpenIdSuccess = createActionCreator(loginOpenId.success);
export const requestLoginOpenIdFailure = createActionCreator(loginOpenId.failure, 'error');
export const requestOpenId = createActionCreator(openId.request, 'token');
export const requestOpenIdSuccess = createActionCreator(openId.success, 'response');
export const requestOpenIdFailure = createActionCreator(openId.failure, 'error');
export const requestSignupOpenId = createActionCreator(signupOpenId.request, 'payload');
export const requestSignupOpenIdSuccess = createActionCreator(signupOpenId.success);
export const requestSignupOpenIdFailure = createActionCreator(signupOpenId.failure, 'error');
